var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2Colored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 219.5,
    fill: "#fdd402"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbf13",
    d: "M96.5,256C96.5,144.95184,178.969,53.17993,286,38.5495A221.37921,221.37921,0,0,0,256,36.5C134.7735,36.5,36.5,134.7735,36.5,256S134.7735,475.5,256,475.5a221.37921,221.37921,0,0,0,30-2.0495C178.969,458.82007,96.5,367.04816,96.5,256Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#74563a",
    d: "M165.5 230A35.54028 35.54028 0 0 1 130 194.5a7.5 7.5 0 0 1 15 0 20.5 20.5 0 0 0 41 0 7.5 7.5 0 0 1 15 0A35.54028 35.54028 0 0 1 165.5 230zM346.5 230A35.54028 35.54028 0 0 1 311 194.5a7.5 7.5 0 0 1 15 0 20.5 20.5 0 0 0 41 0 7.5 7.5 0 0 1 15 0A35.54028 35.54028 0 0 1 346.5 230zM368.55664 388.00146a7.4972 7.4972 0 0 1-6.54541-3.82763 117.92174 117.92174 0 0 0-55.22266-50.1294A116.55966 116.55966 0 0 0 259.5 324.14014h-7a116.57358 116.57358 0 0 0-47.2959 9.90332 118.4576 118.4576 0 0 0-55.21435 50.1289 7.50013 7.50013 0 0 1-13.07911-7.34472 133.55143 133.55143 0 0 1 62.24854-56.51221A131.47793 131.47793 0 0 1 252.5 309.14014h7a132.16887 132.16887 0 0 1 93.69336 38.80664 132.92018 132.92018 0 0 1 21.895 28.87939 7.50238 7.50238 0 0 1-6.53174 11.17529z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Colored);
export default __webpack_public_path__ + "static/media/2-colored.4120b2ccca0aa1f894a0dda53ea2ff7b.svg";
export { ForwardRef as ReactComponent };